import { getInLocalStorage } from '@trqk/utils';

const nodeEnv = process.env.NODE_ENV;
const createReactAppEnv = process.env.REACT_APP_CUSTOM_NODE_ENV;

export const featureFlags: FeatureFlags = {
    // local development
    localDevelopment: {
        apolloClientErrorDialog: true,
        checkForDataMigration: false,
        clientEventsPage: true,
        gapAnalysisLinksToPerformancesTable: true,
        limitStatementUploadBatchSize: true,
        limitStatementUploadFileSize: false,
        paywall: true,
        truncateChartData: false,
    },
    // dev.trqk.io
    development: {
        apolloClientErrorDialog: true,
        checkForDataMigration: false,
        clientEventsPage: true,
        gapAnalysisLinksToPerformancesTable: true,
        limitStatementUploadBatchSize: false,
        limitStatementUploadFileSize: false,
        paywall: true,
        truncateChartData: false,
    },
    // staging.trqk.io
    staging: {
        apolloClientErrorDialog: false,
        checkForDataMigration: false,
        clientEventsPage: true,
        gapAnalysisLinksToPerformancesTable: true,
        limitStatementUploadBatchSize: true,
        limitStatementUploadFileSize: false,
        paywall: true,
        truncateChartData: false,
    },
    // iq.trqk.io
    production: {
        apolloClientErrorDialog: false,
        checkForDataMigration: false,
        clientEventsPage: false,
        gapAnalysisLinksToPerformancesTable: false,
        limitStatementUploadBatchSize: true,
        limitStatementUploadFileSize: false,
        paywall: true,
        truncateChartData: false,
    },
};

export const getFeatureFlags = (): { [key: string]: boolean } => {
    if (createReactAppEnv === 'development') {
        return getInLocalStorage('featureFlags') ?? featureFlags.development;
    }

    if (createReactAppEnv === 'staging') {
        return featureFlags.staging;
    }

    if (createReactAppEnv === 'test') {
        return featureFlags.production;
    }

    if (nodeEnv === 'production') {
        return featureFlags.production;
    }

    if (nodeEnv === 'development') {
        return (
            getInLocalStorage('featureFlags') ?? featureFlags.localDevelopment
        );
    }

    return featureFlags.localDevelopment;
};

export const getFlagForBuildEnvironment = (
    flag: FeatureFlagName,
    environment: Environment,
): boolean => featureFlags[environment][flag];

export const isMissingFlagName = (prev: Record<string, boolean>): boolean =>
    Object.keys(featureFlags.development).some(
        (flagName: string): boolean => prev[flagName] === undefined,
    );
